import shared from '../../pages/00_resumes/SharedCSS.module.css';
import { useLocation } from 'react-router-dom';
import { Vline } from "../../components/icons/all-icons";
import resume from '../../pages/00_resumes/resume/Resume.module.css'
import rlresume from '../../pages/00_resumes/RLresume/RLresume.module.css'

function Card({ 
  start = "####", 
  end = "####", 
  title = "Title", 
  subtitle1 = "Primary Subtitle", 
  subtitle2 = "Secondary Subtitle", 
  className, 
  link 
}) {

  const { pathname } = useLocation();
  const isResume = pathname === '/resume';
  const isRL = pathname === '/real-life-resume';

  return (
    <div className={className}>
      <div className={`${shared.dates} ${isResume ? resume.dates : ''} ${isRL ? rlresume.dates : ''}`}>
        <Vline className={`${shared.vline} ${isResume ? resume.vline : ''} ${isRL ? rlresume.vline : ''}`}/>
        <div className={shared.date}>
          <div className={shared.data}>{start}</div>
          {/\d/.test(start) && (
            <div className={shared.mobileTextLine}>—</div>
          )}
          <div className={shared.data}>{end}</div>
        </div>
      </div>
      <div className={`${shared.info} ${resume.info} ${rlresume.info}`}>
        <h1>{title}</h1>
        <h2>
            <span>{subtitle1}</span>
            {subtitle2 && <span className={shared.mobileTextLine}>—</span>}
            <span>
                {subtitle2}{" "}
                {link && (
                    <a className={`${shared.studyCase} ${isResume ? resume.studyCase : ''} ${isRL ? rlresume.studyCase : ''}`} href={link} target="_blank" rel="noreferrer">
                        See StudyCase
                    </a>
                )}
            </span>
        </h2>
      </div>
    </div>
  );
}

export default Card;
